const ACTIVE_CLASS = 'is-active';
const LOCKED_CLASS = 'is-locked';
const bodyOverlay = document.querySelector('.body-overlay');

let startDate;
let endDate;

function displayPopup() {
  if (!document.querySelector('.product-date-range')) {
    return;
  }

  limitedReleasePopup?.classList.add(ACTIVE_CLASS);

  const title = limitedReleasePopup?.querySelector('p');
  title.textContent = document.querySelector('.product-date-range')?.dataset.title;

  const imageElement = limitedReleasePopup?.querySelector('img');
  const productImage = document.querySelector('.product-date-range')?.dataset.image;
  imageElement.src = productImage;

  bodyOverlay?.classList.add(ACTIVE_CLASS);
  document.body.classList.add(LOCKED_CLASS);
}

function removeLineItem() {
  const productDateRangeEl = document.querySelector('.product-date-range');

  if (!productDateRangeEl) return console.error('[removeLineItem] Error: no product date range element');

  fetch(productDateRangeEl.dataset.productUrlToRemove, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error('[removeLineItem] Error: ', data);
      } else {
        // success
        // console.log('[removeLineItem] Success: ', data)
      }
    });
}

function hidePopup() {
  limitedReleasePopup?.classList.remove(ACTIVE_CLASS);
  bodyOverlay?.classList.remove(ACTIVE_CLASS);
  document.body.classList.remove(LOCKED_CLASS);
}

function isDateInRange(pickedDateStr, startDateStr, endDateStr) {
  const currentDate = new Date(pickedDateStr);
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Set the time to 00:00:00 for all dates to compare dates only
  currentDate.setHours(0, 0, 0, 0);
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  return currentDate >= startDate && currentDate <= endDate;
}

// "DOMContentLoaded" event listener
document.addEventListener('DOMContentLoaded', function () {
  const dateRangeHolder = document.querySelector('.product-date-range');
  startDate = dateRangeHolder?.dataset.startDate;
  endDate = dateRangeHolder?.dataset.endDate;

  if (!dateRangeHolder || !startDate || !endDate) {
    return;
  }

  console.log({ dateRangeHolder, startDate, endDate });
});

// MutationObserver
const container = document.querySelector('.hidden-for-terms');
const config = { attributes: true, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  let input = document.querySelectorAll('.picker__day:not(.picker__day--disabled)');
  // document.querySelector("[name='datetime']") ||
  // document.querySelector("#deliveryGeoSearchField");

  // input?.forEach(element => {
  //   element.removeEventListener('click', getDateFromZapiet);
  // });
  input?.forEach((dateButton) => {
    dateButton.addEventListener('click', function (e) {
      let attemptCount = 0;
      const maxAttempts = 30;
      sessionStorage.setItem('pickedDateVerified', false);
      const interval = setInterval(function (e) {
        if (sessionStorage.getItem('pickedDateVerified') == 'true') {
          clearInterval(interval);
          return;
        }
        attemptCount++;
        
        if (attemptCount > maxAttempts) {
          clearInterval(interval);
          return;
        }
        
        let pickedDate = document.querySelector('[name="datetime"]').value;
        if (!pickedDate) {
          return;
        }
        
        const savedPickedDate = sessionStorage.getItem('pickedDate');
        if (sessionStorage.getItem('pickedDateVerified') == 'false' && pickedDate === savedPickedDate) {
          // picked date has not updated yet, retry
          return;
        } else if (pickedDate !== savedPickedDate && sessionStorage.getItem('pickedDateVerified') == 'false') {
          sessionStorage.setItem('pickedDate', pickedDate);
          sessionStorage.setItem('pickedDateVerified', true);
          
          if (!isDateInRange(pickedDate, startDate, endDate)) {
            removeLineItem();
            displayPopup();
            clearInterval(interval);
          } 
        }
      }, 200);
    });
  });
  // if (!isDateInRange(startDate, endDate)) {
  //   e.preventDefault();
  //   displayPopup();
  // }
  /*
    bodyOverlay?.addEventListener("click", function (e) {
      hidePopup();
    });

    closePopupButton?.addEventListener("click", function (e) {
      hidePopup();
    });
    */
};

const observer = new MutationObserver(callback);

observer.observe(container, config);
